import { mxgraphInstance } from './mxgraphFactory';
/**
 * Handler
 */
export var mxCellHighlight = mxgraphInstance.mxCellHighlight;
export var mxCellMarker = mxgraphInstance.mxCellMarker;
export var mxCellTracker = mxgraphInstance.mxCellTracker;
export var mxConnectionHandler = mxgraphInstance.mxConnectionHandler;
export var mxConstraintHandler = mxgraphInstance.mxConstraintHandler;
export var mxEdgeHandler = mxgraphInstance.mxEdgeHandler;
export var mxEdgeSegmentHandler = mxgraphInstance.mxEdgeSegmentHandler;
export var mxElbowEdgeHandler = mxgraphInstance.mxElbowEdgeHandler;
export var mxGraphHandler = mxgraphInstance.mxGraphHandler;
export var mxHandle = mxgraphInstance.mxHandle;
export var mxKeyHandler = mxgraphInstance.mxKeyHandler;
export var mxPanningHandler = mxgraphInstance.mxPanningHandler;
export var mxPopupMenuHandler = mxgraphInstance.mxPopupMenuHandler;
export var mxRubberband = mxgraphInstance.mxRubberband;
export var mxSelectionCellsHandler = mxgraphInstance.mxSelectionCellsHandler;
export var mxTooltipHandler = mxgraphInstance.mxTooltipHandler;
export var mxVertexHandler = mxgraphInstance.mxVertexHandler;
//# sourceMappingURL=Handler.js.map